<template>
  <div>
    <h1>Account</h1>
    <div class="form-group">
      <label>Selected Account:</label>
      <div class="input-group">
        <span v-if="account" class="chosen-account">{{ account.id }} - {{ account.email }}</span>
        <span v-else class="chosen-account">No account selected</span>
        <div class="account-buttons">
          <button v-if="account" class="btn btn-default" type="button" v-on:click="setAccount(null)">Clear</button>
          <button v-if="isAccountDirty" class="btn btn-default" type="button" v-on:click="resetAccount(null)">Reset</button>
        </div>
      </div>
    </div>

    <div>
      <form @submit="onSearchSubmit" class>
        <div class="form-group">
          <label for="account-email">Search By Email Address</label>
          <input v-model="searchEmail" @input="onUserSearchInput" type="text">
        </div>
      </form>

      <div class="search-result-container">
        <ul>
          <span v-if="searchResults.length==0 && this.searchEmail">[no search results]</span>
          <span v-if="searchResults.length>0">Select an account below</span>
          <li v-for="account in searchResults" v-bind:key="account.id">
            <a v-on:click="setAccount(account)">{{account.id }} - {{ account.email }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";

export default {
  name: "AccountPolicyPart",
  props: ["account"],
  data: function() {
    return {
      searchEmail: "",
      searchResults: []
    };
  },
  computed: {
    ...mapState(["original_policy_data", "isAccountDirty"])
  },
  methods: {
    ...mapActions(["setAccount", "resetAccount"]),
    onUserSearchInput: function() {
      this.searchQuery(this.searchEmail);
    },
    onSearchSubmit: function(e) {
      e.preventDefault();
      this.searchQuery(this.searchEmail);
    },
    searchQuery: function(q) {
      axios
        .get("/staff-api/user-search", {
          params: {
            q: q
          }
        })
        .then(response => {
          let accounts = response.data;
          this.searchResults = accounts;
        });
    }
  }
};
</script>

<style>
.chosen-account {
  line-height: 2em;
}
</style>
